export const getFsExcludeClassName = (fsExclude: boolean | undefined) =>
  fsExclude && "fs-exclude";
